<template>
  <div class="main-container">
    <div class="users-control">
      <div class="users-control__left">
        <main-menu></main-menu>
      </div>
      <div class="users-control__right">
        <h2 class="main-title">Users control</h2>

        <div class="btns-row">
          <div class="users-control__arenas-select">
            <Loader v-if="areCRMsLoading"></Loader>
            <select class="form__select"
                    v-if="CRMsList.length && !areCRMsLoading"
                    v-model="chosenCRM"
                    @change="getUsers">
              <option disabled value="">Choose CRM Account</option>
              <option
                v-for="(CRM, i) in CRMsList"
                :key="CRM + i"
                v-bind:value="CRM">{{CRM}}</option>
            </select>
          </div>

          <div class="btns-row__right-btns">
            <button v-if="$checkRoles(['Administrator'])"
                    class="ark-btn ark-btn--success"
                    @click="toggleCreateForm(true)">
                  Create user
            </button>
          </div>
        </div>

        <div class="users-control__wrap">
          <Loader v-if="areUsersLoading"></Loader>

          <table class="table users-table" v-if="!areUsersLoading && users.length">
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Arena type</th>
              <th>Created at</th>
              <th>Action</th>
            </tr>
            <tr v-for="user in users" :key="user.user_id" class="games__item">
              <td>{{user.name}}</td>
              <td>{{user.email}}</td>
              <td>{{user.app_metadata.arena_type}}</td>
              <td>{{user.created_at | moment("DD MMMM YYYY")}}</td>
              <td>
                <button v-if="$checkRoles(['Administrator'])"
                        @click="removeUser(user)"
                        class="ark-btn ark-btn--danger"
                        :disabled="userToDel"
                >
                  <Loader v-if="userToDel === user.user_id"></Loader>
                  <span v-else>Remove user</span>
                </button>
              </td>
            </tr>
          </table>

          <UsersCreateForm
            v-if="isUserCreateFormVisible"
            :chosenCRM="chosenCRM"
            :toggleCreateForm="toggleCreateForm"
            :getAllCRMs="getAllCRMs"
          ></UsersCreateForm>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import config from '../../../config'
  import Loader from '../../Loader/Loader.vue'
  import UsersCreateForm from '../UsersCreateFormPopup/UsersCreateFormPopup.vue'
  import MainMenu from '../../MainMenu/MainMenu.vue'

  export default {
    name: 'UsersControlMain',
    components: {MainMenu, UsersCreateForm, Loader},
    data () {
      return {
        CRMsList: [],
        areCRMsLoading: false,
        areUsersLoading: false,
        users: [],
        chosenCRM: '',
        successMsgs: [],
        errorMsgs: [],
        isUserCreateFormVisible: false,
        userToDel: null
      }
    },
    created: function () {
      this.getAllCRMs()
    },
    methods: {
      getAllCRMs: function (preSelectValue) {
        this.areCRMsLoading = true

        this.$http.get(`${config.apiUrl}/portal-user/partner/list`)
          .then(response => {
            this.areCRMsLoading = false
            this.CRMsList = response.body
            if (preSelectValue) {
              for (let index = 0; index < this.CRMsList.length; index++) {
                let partnerName = this.CRMsList[index]
                if (partnerName === preSelectValue) {
                  this.chosenCRM = partnerName
                  this.getUsers()
                  break
                }
              }
            }
          }, error => {
            this.areCRMsLoading = false
            console.log(error)
          })
      },
      getUsers: function () {
        this.areUsersLoading = true

        let partnerName = encodeURIComponent(this.chosenCRM)
        this.$http.get(`${config.apiUrl}/portal-user/list?partnerName=${partnerName}`)
          .then(response => {
            this.areUsersLoading = false
            this.users = response.body
          }, error => {
            this.areUsersLoading = false
            console.log(error)
          })
      },
      toggleCreateForm: function (bool) {
        this.isUserCreateFormVisible = bool
      },
      removeUser: function (user) {
        this.userToDel = user.user_id

        this.$http.delete(`${config.apiUrl}/portal-user/delete/${user.user_id}`)
          .then(() => {
            this.users = this.users.filter((user) => {
              return user.user_id !== this.userToDel
            })
            this.userToDel = null
          }, error => {
            this.userToDel = null
            console.log(error)
          })
      }
    }
  }
</script>

<style scoped src="./UsersControlMain.scss" lang="scss"></style>
